import { render, staticRenderFns } from "./ASC_BasicSummaryPrintable.vue?vue&type=template&id=04f4ca18&scoped=true&"
import script from "./ASC_BasicSummaryPrintable.vue?vue&type=script&lang=js&"
export * from "./ASC_BasicSummaryPrintable.vue?vue&type=script&lang=js&"
import style0 from "./ASC_BasicSummaryPrintable.vue?vue&type=style&index=0&id=04f4ca18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f4ca18",
  null
  
)

export default component.exports